app.controller("AddStudentSelectionController", [
    "$scope", "$interpolate", "$uibModalInstance", "$q", "StaticData", "ConfirmModal", "toastr", "Selection", "Students", "params",
    function ($scope, $interpolate, $uibModalInstance, $q, StaticData, ConfirmModal, toastr, Selection, Student, params) {
        $scope.chosenStudent = params.student || null;
        $scope.activation = null;
        $scope.sessions = params.sessions;

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.daysMap = _.keyBy(days, '_id');
        });

        $scope.getStudents = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Student.list({query: query, state: "active"}).then(function (data) {
                return data.docs;
            });
        };

        function checkGroups() {
            return $q.all([
                Student.checkStudentGroupCollision($scope.chosenStudent._id, $scope.lecture),
                Student.checkStudentGroupCollision($scope.chosenStudent._id, $scope.seminar),
            ]).then(function (results) {
                return {
                    lecture: results[0],
                    seminar: results[1]
                }
            })
        }

        function getWarningHTML(warningData) {
            // var user = $scope.chosenStudent.user;
            $scope.collisions = warningData;
            var html = '<h3>სტუდენტისთვის <b>{{chosenStudent.user.firstName}} {{chosenStudent.user.lastName}}</b> აღმოჩენილია დამთხვევები სხვა საგნებზე</h3><br>';

            if (warningData.lecture.length) {
                html += '<h4>ლექციები:</h4>';
                for (var i in warningData.lecture) {
                    html += '<div>';
                    html += '<span style="color: #d72926;">{{daysMap[collisions.lecture[' + i + '].dayOfWeek].name}} {{collisions.lecture[' + i + '].startTime | date:\'HH:mm\' }}</span> ' +
                        'საგანზე "{{collisions.lecture[' + i + '].sessionGroup.subject.name}}", ჯგუფი - "{{collisions.lecture[' + i + '].sessionGroup.title}}"';
                    html += '</div>';
                }
            }

            if (warningData.seminar.length) {
                html += '<h4>სემინარები:</h4>';
                for (var i in warningData.seminar) {
                    html += '<div>';
                    html += '<span style="color: #d72926;">{{daysMap[collisions.seminar[' + i + '].dayOfWeek].name}} {{collisions.seminar[' + i + '].startTime | date:\'HH:mm\' }} </span>' +
                        'საგანზე "{{collisions.seminar[' + i + '].sessionGroup.subject.name}}", ჯგუფი - "{{collisions.seminar[' + i + '].sessionGroup.title}}"';
                    html += '</div>';
                }
            }
            return $interpolate(html)($scope);
        }

        $scope.add = function () {
            if (!$scope.chosenStudent || !$scope.chosenStudent._id) {
                return toastr.error('სტუდენტი არაა არჩეული სრულად.');
            }

            $scope.checking = true;
            checkGroups().then(function (result) {
                if (result.lecture.length || result.seminar.length) {
                    ConfirmModal.show({
                        title: "ყურადღება !",
                        html: getWarningHTML(result),
                        size: 'md'
                    }).result.then(function () {
                        $scope.checking = false;
                        return addSelection();
                    }).catch(function () {
                        $scope.checking = false;
                    })
                } else {
                    $scope.checking = false;
                    return addSelection();
                }
            });
        };

        function addSelection() {
            $scope.checking = true;
            Selection.addSelection({
                student: $scope.chosenStudent._id,
                subjectActivation: params.subjectActivation
            }).then(function (selection) {
                $scope.selection = selection;
                return Selection.prove({
                    selection: selection._id,
                    seminar: $scope.seminar,
                    lecture: $scope.lecture
                })
            }).then(function () {
                if (params.update) params.update();
                toastr.success('', $scope.chosenStudent.user.firstName + ' ' + $scope.chosenStudent.user.lastName + ' ' + 'დამატებულია ' + params.subjectName + '-ზე');
                $scope.chosenStudent = null;
                $scope.checking = false;
                if (params.close) {
                    $uibModalInstance.close();
                }
            }).catch(function (err) {
                $scope.checking = false;
                if (err.status === 400) toastr.error('', $scope.chosenStudent.user.firstName + ' ' + $scope.chosenStudent.user.lastName + ' ' + 'უკვე დამატებულია საგანზე');
                if (err.status === 423) toastr.error('', 'საგანი დაბლოკილია წინაპირობის გამო');
                if (err.status === 500) toastr.error('', 'დაფიქსირდა სერვერის შეცდომა');
            });
        }

        $scope.close = function () {
            $uibModalInstance.close();
        };
    }
]);